import React from "react";
import "./Frame1135.css";

function Frame1135(props) {
  const { className } = props;

  return (
    <div className={`frame-113-46 ${className || ""}`}>
      <div className="lean-vsm-2 valign-text-middle inter-medium-star-dust-18px">Lean VSM</div>
    </div>
  );
}

export default Frame1135;
